import { useAccount } from "wagmi";
import {
  LoadingSkeleton,
  Typography,
  WalletAddressRedesign,
} from "../../../../components";
import { config } from "../../../../config";
import { useAppSelector } from "../../../../redux";
import { formatBigNumber } from "../../../../utils";
import * as S from "./WalletBar.styled";
import { ConnectWalletButton } from "../../../../features";

export const WalletBar = () => {
  const { address, isConnected } = useAccount();

  const { balances, loading } = useAppSelector((state) => state.wallet);

  return (
    <S.Header
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.35 }}
    >
      {/* <S.WalletWrapper>
        {isDesktopView ? (
          <Typography.HeaderMedium>Wallet</Typography.HeaderMedium>
        ) : null}
        {isConnected && address && <WalletAddress address={address} />}
      </S.WalletWrapper>
      {!isConnected ? <DisconnectedWalletInfo /> : <ConnectedWalletInfo />} */}
      <S.WalletWrapper>
        <S.WalletConatiner>
          <Typography.IngraTitle fontWeight={600}>WALLET</Typography.IngraTitle>
          {isConnected && address && (
            <WalletAddressRedesign address={address} />
          )}
          {!isConnected && <ConnectWalletButton small />}
        </S.WalletConatiner>
        <S.BalanceContainer>
          <Typography.IngraTitle fontWeight={600}>
            BALANCE
          </Typography.IngraTitle>
          <S.Balance>
            {loading ? (
              <LoadingSkeleton width="50px" />
            ) : (
              <Typography.Balance fontWeight={700}>
                {Number(
                  formatBigNumber(balances.usdc, config.USDC_TOKEN_DECIMALS, 0)
                )
                  .toLocaleString("en-US")
                  .replaceAll(",", " ")}{" "}
                {config.STABLE_TOKEN}
              </Typography.Balance>
            )}
            <S.VerticalGreenLine />
            {loading ? (
              <LoadingSkeleton width="50px" />
            ) : (
              <Typography.Balance fontWeight={700}>
                {Number(
                  formatBigNumber(balances.soil, config.SOIL_TOKEN_DECIMALS, 0)
                )
                  .toLocaleString("en-US")
                  .replaceAll(",", " ")}{" "}
                {config.PROJECT_TOKEN}
              </Typography.Balance>
            )}
          </S.Balance>
        </S.BalanceContainer>
      </S.WalletWrapper>
    </S.Header>
  );
};
